$(document).ready(function() {
  let $form = $(".distributor-select-form");

  if ($form.length === 0) {
    return;
  }

  let $select = $(".distributor-select", $form);
  let $submit = $("input[type=submit]", $form);

  $select.on("change", function(e) {
    $submit.toggleClass("disabled", e.target.value === "");
  });
});
